import { getValueAtPath, withProperties } from "../../utils";

export default function state() {
    const NAME = "country";
    const $state = Object.create(null);

    const { data } = this;

    // Deliberately not falling back to ip_country: that reflects where the payer is
    // browsing from, not where the transaction belongs.
    const country = getValueAtPath(data, 'country');
    const initialCountry = country ? String(country).toUpperCase() : null;

    function Reducer(state = initialCountry) {
        return state;
    }

    withProperties($state, { NAME, Reducer });

    return (state = $state);
}
